module.exports = __webpack_public_path__ + "38c4ead7cbc8aaa34bd1d205bac18ebb.jpg";